@if (options && options.length > 0) {
<div class="sliding-button -container">
  <ul #slidingOptions>
    @for (option of options; track option) {
    <li>
      <a>{{ option }}</a>
    </li>
    }
    <div class="sliding-button -slider" #slider></div>
  </ul>
</div>
}
